import type { Rival, RivalRequest } from '../../types'
import ModalBackdrop from '../ModalBackdrop'
import ModalHeader from '../ModalHeader'
import RivalsList from '../RivalsList'

/** The self-view rivals list, opened from the header's rivals count. */
function RivalsModal({
  rivals,
  incomingRivalRequests,
  onClose,
  onViewRivalProfile,
  onAcceptRivalRequest,
  onDeclineRivalRequest,
}: {
  rivals: Rival[]
  incomingRivalRequests: RivalRequest[]
  onClose: () => void
  onViewRivalProfile: (userId: string, displayName: string) => void
  onAcceptRivalRequest?: (requestId: string) => void
  onDeclineRivalRequest?: (requestId: string) => void
}) {
  return (
    <ModalBackdrop onClose={onClose}>
      <div className="profile__rivals-modal">
        <ModalHeader title="Rivals" onClose={onClose} />
        <RivalsList
          rivals={rivals}
          incomingRequests={incomingRivalRequests}
          onViewProfile={(userId, displayName) => {
            onClose()
            onViewRivalProfile(userId, displayName)
          }}
          onAccept={onAcceptRivalRequest}
          onDecline={onDeclineRivalRequest}
          collapsible={false}
        />
      </div>
    </ModalBackdrop>
  )
}

export default RivalsModal
